import { generateAnimationBasedOnPagePaddings } from './generator/animation.generators';

export default generateAnimationBasedOnPagePaddings(0);
